import { __decorate } from "tslib";
import { observable } from 'mobx';
export default class LookupCache {
}
__decorate([
    observable
], LookupCache.prototype, "items", void 0);
__decorate([
    observable
], LookupCache.prototype, "promise", void 0);
